/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Icon } from '@components/atoms'
import { DragLayerMonitorProps } from '@minoru/react-dnd-treeview'

interface PropsType {
	monitorProps: DragLayerMonitorProps<any>
}

export const NodeDragPreview: React.FC<PropsType> = props => {
	const item = props.monitorProps.item

	return (
		<View css={style}>
			<Icon name="drag-horizontal-variant" className="draggedHandleIcon" />
			{item.text}
		</View>
	)
}

const style = css({
	display: 'flex',
	alignItems: 'center',
	width: 'fit-content',
	marginTop: '-1.2rem',
	marginLeft: '-1rem',
	padding: '4px 8px',
	backgroundColor: '#1967d2',
	boxShadow: '0 12px 24px -6px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.08)',
	borderRadius: '4px',
	color: '#FFF',
	fontSize: '14px',
	pointerEvents: 'none',

	'.draggedHandleIcon': {
		color: '#FFF',
	},
})
